import CandidateProfessionalExperience from './CandidateProfessionalExperience.container';

export default CandidateProfessionalExperience;
